/**
 * @fileoverview ESM mirror of ../extractEnvPrefix.js.
 * @module @puffin-core/cross-app-policy/extractEnvPrefix
 */

import { stripPort } from './hostMatching.js';

function extractEnvPrefix(hostname, subdomain, sourceDefaultDomain) {
  if (typeof hostname !== 'string' || hostname.length === 0) return null;
  if (typeof subdomain !== 'string' || subdomain.length === 0) return null;
  if (typeof sourceDefaultDomain !== 'string' || sourceDefaultDomain.length === 0) return null;

  const host = stripPort(hostname).toLowerCase();
  const sub = subdomain.toLowerCase();
  const domain = sourceDefaultDomain.toLowerCase();

  const expectedPrefix = `${sub}.`;
  if (!host.startsWith(expectedPrefix)) return null;

  const expectedSuffix = `.${domain}`;
  if (host === `${sub}.${domain}`) return '';

  if (!host.endsWith(expectedSuffix)) return null;

  const middle = host.slice(expectedPrefix.length, host.length - expectedSuffix.length);
  if (middle.length === 0) return '';
  if (middle.startsWith('.') || middle.endsWith('.')) return null;

  return middle;
}

export { extractEnvPrefix };
